

import App from './App';
import router from './router';
import Vue from 'vue';
import app from './store/app';

import mylocalstore from '../src/plugins/request/mylocalstore';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);

import DatetimePlugin from 'vux/src/plugins/datetime/index.js';

Vue.use(DatetimePlugin);

import qs from 'qs';
import AjaxPlugin from 'vux/src/plugins/ajax/index.js';
import LoadingPlugin from 'vux/src/plugins/loading/index.js';
import ToastPlugin from 'vux/src/plugins/toast/index.js';
import DevicePlugin from 'vux/src/plugins/device/index.js';

import axios from "axios";
import htmlToPdf from '@/components/utils/htmlToPdf';
Vue.use(htmlToPdf);

Vue.use(AjaxPlugin);
Vue.use(LoadingPlugin);
Vue.use(ToastPlugin);
Vue.use(DevicePlugin);
Vue.prototype.mylocalstore = mylocalstore;
Vue.prototype.app = app;

axios.defaults.timeout = 800000;
Vue.prototype.$http.defaults.baseURL = "http://58.216.159.82:197/attence";
AjaxPlugin.$http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

AjaxPlugin.$http.interceptors.request.use(function (config) {
  console.log(JSON.stringify('-----请求------'));

  Vue.$vux.loading.show({
    text: '加载中'
  });
  if (config.method === 'post') {
    config.data = qs.stringify(config.data);
  }
  return config;
}, function (error) {
  Vue.$vux.loading.hide();
  return Promise.reject(error);
});

AjaxPlugin.$http.interceptors.response.use(function (response) {

  Vue.$vux.loading.hide();

  if (response.data.success) {
    return response.data;
  } else if (response.data.code === 1) {
    return response.data;
  } else {
    Vue.$vux.toast.text(response.data.message, 'bottom');
  }
}, function (error) {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '请求错误(400)';break;
      case 401:
        error.message = '未授权，请重新登录(401)';break;
      case 403:
        error.message = '拒绝访问(403)';break;
      case 404:
        error.message = '请求出错(404)';break;
      case 408:
        error.message = '请求超时(408)';break;
      case 500:
        error.message = '服务器错误(500)';break;
      case 501:
        error.message = '服务未实现(501)';break;
      case 502:
        error.message = '网络错误(502)';break;
      case 503:
        error.message = '服务不可用(503)';break;
      case 504:
        error.message = '网络超时(504)';break;
      case 505:
        error.message = 'HTTP版本不受支持(505)';break;
      default:
        error.message = '\u8FDE\u63A5\u51FA\u9519(' + error.response.status + ')!';
    }
  } else {
    error.message = '连接服务器失败!';
  }
  Vue.$vux.toast.text(error.message, 'bottom');
  Vue.$vux.loading.hide();

  return Promise.reject(error);
});

router.beforeEach(function (to, from, next) {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

Vue.config.productionTip = false;

var VueUploadComponent = require('vue-upload-component');
Vue.component('file-upload', VueUploadComponent);
/* eslint-disable no-new */
new Vue({
  router: router,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app-box');


// WEBPACK FOOTER //
// ./src/main.js